module.exports = __webpack_public_path__ + "img/ic_standard_eu.cb2c11e0.png";